import { useState } from "react";
import { Star } from "@phosphor-icons/react";
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ReviewDialog({ booking, onDone }) {
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/reviews", { booking_id: booking.id, rating, comment });
      toast.success("Review submitted");
      setOpen(false);
      onDone && onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not submit");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid={`review-open-${booking.id}`} size="sm" variant="outline" className="border-yellow-300 text-yellow-800 hover:bg-yellow-50">
          <Star size={14} className="mr-1" weight="fill" /> Leave review
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>Rate this shift</DialogTitle></DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <div className="label-caps mb-2">Your rating</div>
            <div className="flex gap-1">
              {[1,2,3,4,5].map((n) => (
                <button key={n} data-testid={`star-${n}`} onClick={() => setRating(n)} type="button">
                  <Star size={32} weight={n <= rating ? "fill" : "regular"} className={n <= rating ? "text-yellow-400" : "text-slate-300"} />
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="label-caps mb-2">Comment (optional)</div>
            <Textarea data-testid="review-comment" rows={3} value={comment} onChange={(e)=>setComment(e.target.value)} placeholder="How did it go?" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={()=>setOpen(false)}>Cancel</Button>
          <Button data-testid="review-submit-btn" onClick={submit} disabled={busy} className="bg-blue-600 hover:bg-blue-700">
            {busy ? "Submitting…" : "Submit review"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
